export const parseFormInputAsFloat = (
  inputValue: string,
  expectedDecimals: number,
  strictMode: boolean = true,
): string => {
  if (inputValue === '') return '';

  let parsedInputValue = inputValue.replace(',', '.');

  if (strictMode) {
    const parsedInput = parseFloat(parsedInputValue);
    if (isNaN(parsedInput)) return '';
    parsedInputValue = parsedInput.toString();
  } else {
    // add '1' add the end of the input to prevent parseFloat to remove potential trailing '.' or 0
    const parsedInput = parseFloat(parsedInputValue + '1');
    if (isNaN(parsedInput)) return '';
    parsedInputValue = parsedInput.toString();
    parsedInputValue = parsedInputValue.substring(0, parsedInputValue.length - 1);
    if (parsedInputValue === '') {
      return '0';
    }
  }

  if (!parsedInputValue.includes('.')) {
    return parsedInputValue;
  }

  const splitParsedInput = parsedInputValue.split('.');
  splitParsedInput[splitParsedInput.length - 1] = splitParsedInput[splitParsedInput.length - 1].substring(
    0,
    expectedDecimals,
  );

  return splitParsedInput.join('.');
};

export const formatPercentage = (percentage: number | null, precision: number | null = null): string => {
  if (percentage === null || isNaN(percentage)) return '0 %';
  const options = precision
    ? { minimumFractionDigits: precision, maximumFractionDigits: precision }
    : { minimumFractionDigits: 3, maximumFractionDigits: 5 };

  return `${new Intl.NumberFormat('fr-FR', options).format(percentage * 100)} %`;
};

export const formatNumber = (number: number | null): string => {
  if (number === null || isNaN(number)) return '0 %';
  return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 8, maximumFractionDigits: 8 }).format(number);
};

export const compare3DigitsFloats = (number1: number, number2: number): boolean => {
  // We need to do this because js records floats approximately
  return Math.round(number1 * 1000) === Math.round(number2 * 1000);
};
